import * as React from "react";
import { Tooltip } from "primereact/tooltip";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../Landing/Components/Api/Api";
import DataTableTemplate from "../Components/DataTableTemplate";
import { PanelContainer } from "../Components/PanelContainer";
import { fetchData } from "../Components/Utilities";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const UserDetail = () => {
  const [defaultDatatableRows, setDefaultDatatableRows] = useState(10);
  const cols = [
    {
      field: "Mob",
      header: "ردیف",
      body: (data, options) => options.rowIndex + 1,
    },
    {
      field: "Mob",
      header: "نام و نام خانوادگی",
      body: (data, options) => data?.Name + " " + data?.Family,
    },
    {
      field: "Mob",
      header: "جنسیت",
      body: (data) => (data.sex === 1 ? "مرد" : "زن"),
    },
    {
      field: "Mob",
      header: "شماره موبایل",
    },
    { field: "RegDate", header: "تاریخ عضویت" },
    { field: "coin", header: " آخرین ورود" },
    {
      field: "CityName",
      header: "تعداد سکه",
      body: (data) => (
        <a
          className="text-decoration-underline"
          onClick={() => navigate(`/cpanel/users/${data?.uid}`)}
        >
          {formatNumber(data?.coin)}
        </a>
      ),
    },
    {
      field: "CityName",
      header: "تعداد زیرمجموعه مستقیم",
      body: (data) => (
        <a
          className="text-decoration-underline"
          onClick={() => navigate(`/cpanel/users/detail/${data?.uid}`)}
        >
          {data?.referral}
        </a>
      ),
    },
  ];
  function formatNumber(number) {
    // Round to one decimal place
    let roundedNumber = parseFloat(number.toFixed(1));

    // Remove trailing zeros if the number is an integer
    if (roundedNumber % 1 === 0) {
      roundedNumber = parseInt(roundedNumber);
    }

    return roundedNumber;
  }
  const navigate = useNavigate();
  const { userId } = useParams();
  const dt = useRef(null);

  const [defaultRows, setDefaultRows] = useState(20);
  const [userList, setUserList] = useState([]);
  const [lazyState, setLazyState] = useState({
    first: 0,
    page: 0,
    rows: defaultRows,
  });
  const [totalRecords, setTotalRecords] = useState(0);
  const fetchdata = async (e) => {
    const bodyFormData = new FormData();
    bodyFormData.append("uid", userId);

    try {
      const response = await axios.post(BASE_URL, bodyFormData, {
        headers: {
          "Content-type": "multipart/form-date",
          Accept: "application/json",
          cmd: "referrallist",
        },
      });
      if (response.status === 200) {
        const data = await response;
        setUserList(data.data.dt);
        setTotalRecords(data?.data?.count);
      } else {
        console.error(`API request failed with status: ${response.status}`);
      }
    } catch (error) {
      throw new Error("Cpanel detail cpanel route Error: ", error.message);
    }
  };

  useEffect(() => {
    const bodyFormData = new FormData();
    bodyFormData.append("uid", userId);
    fetchData("referrallist", bodyFormData, handleApiResponse);
  }, [lazyState]);
  const handleApiResponse = (data) => {
    setUserList(data?.dt);
    setTotalRecords(data?.count);
  };
  return (
    <>
      <button
        className=" btn btn-outline-secondary fw-bold d-flex align-items-center gap-2 mb-1"
        onClick={() => navigate(-1)}
      >
        <span>
          {" "}
          <FontAwesomeIcon
            icon={"arrow-right"}
            className="fa-small "
          ></FontAwesomeIcon>{" "}
        </span>
        <span>بازگشت</span>
      </button>
      <PanelContainer title={" اطلاعات کاربران زیرمجموعه"}>
        <Tooltip
          target=".export-buttons>button"
          position="bottom"
          key={"index"}
        />
        <DataTableTemplate
          lazyState={lazyState}
          // select='select'
          className={"table-border"}
          columns={cols}
          list={userList}
          totalRecords={totalRecords}
          setlazyState={setLazyState}
          setDefaultDatatableRows={setDefaultDatatableRows}
          defaultDatatableRows={defaultDatatableRows}
          width="25rem"
        />
      </PanelContainer>
    </>
  );
};
